import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import { toast, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { APIHandler } from 'C4';
import InputField from '../Input';
import { userInputBlank } from '../LoginForm';

const CheckDatabase = ({
  quit,
  batchChange,
  registerHandler,
  shows,
  individualShowData,
  ...props
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tokens, set_tokens] = useState({ access_token: '', refresh_token: '' });

  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);

    if (!email || !password) {
      toast.error('Please fill in all fields.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      setLoading(false);
      setPassword('');
      return;
    }

    if (shows.length === 0) {
      toast.error('Please select a show', {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      setLoading(false);
      return;
    }

    APIHandler.getUser(0, email).then((response) => {
      console.log(response.response.email);
      if (!response.response || !response.response.email) {
        toast.error(
          'No account found. Please check your email address and try again or sign up for an account.',
          {
            position: toast.POSITION.TOP_CENTER,
          },
        );

        setLoading(false);
        return;
      }
      const data = {
        email: response.response.email,
        reg_email: response.response.email,
        reg_password: password,
        reg_passwordConfirm: password,
        reg_agency_name: response.response.agency_name,
        reg_first_name: response.response.first_name,
        reg_last_name: response.response.last_name,
        // reg_experience: '',
        reg_owner: response.response.owner,
        reg_city: response.response.city,
        reg_state: response.response.state,
        reg_zip_code: response.response.zip_code,
        reg_phone_number: response.response.phone,
        reg_title: response.response.title,

        reg_agency_business: response.response.agency_business,
        reg_agency_affiliation: response.response.agency_affiliation,

        reg_travel_type_1: response.response.travel_type_1,
        reg_travel_type_2: response.response.travel_type_2,
        reg_travel_type_3: response.response.travel_type_3,

        reg_destination_1: response.response.destination_1,
        reg_destination_2: response.response.destination_2,
        reg_destination_3: response.response.destination_3,

        reg_id_number: response.response.id_number,
        reg_id_type: response.response.id_type,

        reg_custom_1: response.response.custom_1,
        reg_website: '',

        family: shows.includes('family'),
        adventure: shows.includes('adventure'),
        aars: shows.includes('aars'),
        luxury: shows.includes('luxury'),
        europe: shows.includes('europe'),
        romance: shows.includes('romance'),

        // registration_code: response.response.registration_code || '',
        marketing_opt_in: response.response.marketing_opt_in,
      };
      const output = Object.assign(userInputBlank, data);

      batchChange(output);
      setLoading(false);
      registerHandler(email, password);
    });
  };

  const handleNoAccount = () => {
    quit();
  };

  return (
    <div>
      <p>
        {
          'Enter your email address to get started.  If you already have an account with us, we’ll fast track your registration process.'
        }
      </p>
      <InputField
        defaultVal={props.defaultVal}
        change={(e) => setEmail(e.target.value)}
        fieldType="email"
        fieldName="reg_email"
        fieldPlaceholder="Email"
        icon="at"
        focus
      />

      <InputField
        change={(e) => setPassword(e.target.value)}
        fieldType="password"
        fieldName="reg_password"
        fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
        icon="key"
        line
      />

      <div className="login__form--buttons">
        <p className="legal noAccountBtn" onClick={handleNoAccount}>
          <span style={{ color: individualShowData ? individualShowData.primary_color : '' }}>
            {"I don't have an account"}
          </span>
        </p>
        <button
          onClick={handleSubmit}
          className="Email__input--button"
          disabled={loading}
          type="button"
          style={{ backgroundColor: individualShowData ? individualShowData.primary_color : '' }}
        >
          {loading ? (
            <span>
              <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
            </span>
          ) : (
            'Sign Up'
          )}
        </button>
      </div>
      <a
        href="https://chat.travpromobile.com/password/reset"
        target="_blank"
        rel="noreferrer noopener"
        className="Email__input--forgotPassword-btn"
      >
        <span className="Email__input--forgotPassword">{'Forgot Password?'}</span>
      </a>

      <ToastContainer draggablePercent={70} />
    </div>
  );
};

export default CheckDatabase;
